import Vue from 'vue'
import App from './App.vue'
import store from '@/store/index'
import router from '@/router/index'
import RocketUI from '@aiwins/admin-ui'
import './styles/element-variables.scss'
// import 'default-passive-events' // 浏览器mouse事件兼容插件
import '@/icons' // icon
// global css
import '@/styles/index.scss'
import '@/constants/global'
import * as filters from '@/common/filters' 

import '@/permission'
import '@/utils/refreshToken'
import '@/utils/index'
import MyPlugin from './config/myPlugin'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'PE2YHvKPlagTQq6KxscbkCHNSboaIOQa'
})
Vue.use(MyPlugin)
import Print from 'vue-print-nb' // 打印插件
Vue.use(Print);
import VueClipboard from 'vue-clipboard2' //复制插件
Vue.use(VueClipboard)
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
import htmlToPdf from '@/utils/htmlToPdf.js' // pdf导出插件
Vue.use(htmlToPdf)
Vue.use(RocketUI);
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

// import VueCookies from 'vue-cookies'
// Vue.use(VueCookies)
// Vue.$cookies.config('1d')
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
